import React, { useEffect, useState } from 'react';
import { Linking } from 'react-native';
import { useAuthStore } from '@/store/auth';
import { useAiSharingConsent, cancelManualAiSharingConsent } from '@/store/aiSharingConsent';
import AiSharingConsentDialog from './AiSharingConsentDialog';

function ConsentPrompt({ accountId, inline, insets }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const decide = async allowed => {
    if (saving || useAuthStore.getState().user?.id !== accountId) return;
    setSaving(true); setError('');
    try { await useAiSharingConsent.getState().choose(accountId, allowed); }
    catch (_) { setError('Your choice could not be saved. Please try again.'); }
    finally { setSaving(false); }
  };
  return <AiSharingConsentDialog visible inline={inline} insets={insets} busy={saving} error={error}
    onAllow={() => decide(true)} onAccountOptions={() => decide(false)}
    onPrivacy={() => Linking.openURL('https://gab.ai/privacy-policy').catch(() => setError('Unable to open this link. Please try again.'))} />;
}

// Native Work already owns a Modal. Draw inside that host rather than asking
// UIKit to present a second modal from the underlying application controller.
export default function ManualAiSharingConsentPrompt({ host = 'app', inline = false, insets }) {
  const accountId = useAuthStore(state => state.user?.id);
  const state = useAiSharingConsent();
  useEffect(() => () => {
    if (useAiSharingConsent.getState().promptHost === host) cancelManualAiSharingConsent();
  }, [host]);
  if (!accountId || state.promptAccountId !== accountId || state.accountId !== accountId
      || state.loading || (state.promptHost || 'app') !== host) return null;
  return <ConsentPrompt key={accountId} accountId={accountId} inline={inline} insets={insets} />;
}
